module.exports = __webpack_public_path__ + "static/media/slide1.b37b5b30.jpg";